.kq{color:var(--gray-900);}